<template>
  <div>
    <label>
      <slot name="content" />
      <input
        v-validate="validateRules"
        :checked="checked"
        :name="name"
        type="checkbox"
        @click="$emit('onChecked', { checked: $event.target.checked })"
      >
      <span :class="{
        'checkmark': true,
        'checkmark-checked': checked,
        'input': true,
        'error': errors.has(name)
      }" />
    </label>
    <span v-if="!showServerError">
      <InputErrorBox
        v-show="errors.has(name)"
        :message="errors.first(name)"
      />
    </span>
    <span v-else>
      <InputErrorBox
        v-show="serverError"
        :message="serverError"
      />
    </span>
  </div>
</template>

<script>
import InputErrorBox from "./ds-input-error-box";

export default {
  name: "DsCheckbox",
  inject: ["$validator"],
  components: {
    InputErrorBox
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    value: {
      type: Boolean,
      default: false
    },
    validateRules: {
      type: String | Object,
      default: ""
    },
    serverError: {
      type: String,
      default: null
    },
    showServerError: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";
@import "../../scss/_mixins.scss";

label {
  display: block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  user-select: none;
  color: #000;
  @include fluid-font($font-regular-size);
  text-transform: none;
  line-height: 21px;
}
label input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border: 2px solid $light-green-color;
  transition: $animation-speed linear;
  border-radius: $border-radius;
  box-shadow: none;
  &:focus,
  &:active {
    box-shadow: none;
  }
}
label input:checked ~ .checkmark {
  background-color: $light-green-color;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
label input:checked ~ .checkmark:after {
  display: block;
}
label .checkmark:after {
  left: 5px;
  top: 1px;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
span.error {
  border-color: $red-error-color;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-checkbox.vue